import { h, Component } from 'preact';

import style from './style.less';

import FullImageTextOverlayCard from '../../../cards/full-image-text-overlay-card';
import HorizontalCard from '../../../cards/horizontal-card';
import SimpleGridCluster from '../../simple-grid-cluster';
import CardHeader from '../../../pieces/card-header';
import { fetchArticleList } from '../../../../lib/data';
import { fetchFromDailyMotionPlaylist } from '../../../../lib/dailymotion';

import { trackingProvider, TrackingProvider, DIMENSION } from '@cube/track';

/**
 * The main cluster used to display a category of information
 * Layout:
 * - half width card with text over image, 2 simple vert cards
 * - 1x6 simple vertical cards
*/
@trackingProvider({
	[DIMENSION.componentpath]: 'RecommendedClusterPhone'
})
export default class RecommendedCluster extends Component {

	state = {
		topAsset: null,
		middleAssets: [],
		bottomAssets: [],
		hasResults: false
	};

	getAssets = (props) => {
		let vamCount = 0, dmCount = 0;

		if (props.dmPlaylist && props.dmLocation) {
			if (props.dmLocation.zone1) dmCount++; else vamCount++;
			if (props.dmLocation.zone2) dmCount+=2; else vamCount+=2;
			if (props.dmLocation.zone3) dmCount+=props.verticalCardCount; else vamCount+=props.verticalCardCount;

			fetchFromDailyMotionPlaylist({ limit: dmCount, ...props }).then( res => {
				if (res.articles && res.articles.length > 0) {
					let newState = { hasResults: true };

					if (props.dmLocation.zone1) {
						newState.topAsset = res.articles[0];
					}
					if (props.dmLocation.zone2) {
						let start = (props.dmLocation.zone1 ? 1 : 0);
						newState.middleAssets = res.articles.slice(start, start+2);
					}
					if (props.dmLocation.zone3) {
						let start = (props.dmLocation.zone1 ? 1 : 0) + (props.dmLocation.zone2 ? 2 : 0);
						newState.bottomAssets = res.articles.slice(start, start+props.verticalCardCount);
					}

					this.setState(newState);
				}
			});
		}
		else {
			// All filled by VAM
			vamCount = 3 + props.verticalCardCount;
			props.dmLocation = { zone1: false, zone2: false, zone3: false };
		}

		return fetchArticleList({
			count: vamCount,
			imageSizes: 'w=640,h=360|w=400,h=300|w=256,h=144',
			...props }
		)
			.then( res => {
				if (res.articles && res.articles.length > 0) {
					let newState = { hasResults: true };

					if (!props.dmLocation.zone1) {
						newState.topAsset = res.articles[0];
					}
					if (!props.dmLocation.zone2) {
						let start = (!props.dmLocation.zone1 ? 1 : 0);
						newState.middleAssets = res.articles.slice(start, start+2);
					}
					if (!props.dmLocation.zone3) {
						let start = (!props.dmLocation.zone1 ? 1 : 0) + (!props.dmLocation.zone2 ? 2 : 0);
						newState.bottomAssets = res.articles.slice(start, start+props.verticalCardCount);
					}

					this.setState(newState);
				}
			});
	};

	static defaultProps = {
		verticalCardCount: 4
	};

	componentWillMount() {
		this.getAssets(this.props);
	}

	render(
		{ theme, title, link, qeId, verticalCardCount, ...props },
		{ topAsset, middleAssets, bottomAssets, hasResults }
	) {
		if (!hasResults) return null;

		return (
			<div class={style.recommendedCluster} qid={qeId}>
				<CardHeader title={title} link={link} qeId={qeId} />
				<div class={style.cards}>
					{ topAsset &&
						<TrackingProvider {...{ [DIMENSION.componentpath]: 'Top', [DIMENSION.clickindex]: 1 }}>
							<FullImageTextOverlayCard
								theme={theme}
								asset={topAsset}
								imageRole="w=640,h=360"
								cardClass={style.fitoCard}
								qeId={qeId + '-top'}
								{...props}
							/>
						</TrackingProvider>
					}
					{ middleAssets.length === 2 &&
						<TrackingProvider {...{ [DIMENSION.componentpath]: 'Middle' }}>
							<SimpleGridCluster
								assets={middleAssets}
								imageRole="w=400,h=300"
								rowCount={1}
								columnCount={2}
								titleLines={4}
								clusterClass={style.sgCluster}
								qeId={qeId + '-middle'}
								{...props}
							/>
						</TrackingProvider>
					}
					{ bottomAssets.length === verticalCardCount && bottomAssets.map((asset, i) => (
						<TrackingProvider {...{ [DIMENSION.componentpath]: 'Bottom', [DIMENSION.clickindex]: i }}>
							<HorizontalCard
								theme={theme}
								asset={asset}
								imageRole="w=256,h=144"
								imageProportion="half"
								showSummary={false}
								titleLines={3}
								cardClass={style.hihCard}
								qeId={qeId + '-bottom-' + i}
								{...props}
							/>
						</TrackingProvider>
					)) }
				</div>
			</div>
		);
	}
}
